import { render } from "./AddFacilityConfig.vue?vue&type=template&id=27151b6c&scoped=true&ts=true"
import script from "./AddFacilityConfig.vue?vue&type=script&lang=ts"
export * from "./AddFacilityConfig.vue?vue&type=script&lang=ts"

import "./AddFacilityConfig.vue?vue&type=style&index=0&id=27151b6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27151b6c"]])

export default __exports__